import { Popconfirm, PopconfirmProps } from "antd";
import { useState } from "react";

export function PopconfirmHook(props: {
  popconfirmAttrs: PopconfirmProps;
  children: (open: () => void) => React.ReactElement;
  requestApi: () => Promise<any>;
  onOk: (data: any) => void;
}) {
  const [state, setState] = useState({ open: false, loading: false });

  return (
    <Popconfirm
      {...props.popconfirmAttrs}
      open={state.open}
      okButtonProps={{ loading: state.loading }}
      onConfirm={() => {
        if (state.loading) return;
        setState((v) => ({ ...v, loading: true }));
        props
          .requestApi()
          .then((data) => props.onOk(data))
          .finally(() =>
            setState((v) => ({ ...v, open: false, loading: false }))
          );
      }}
      onCancel={() => setState((v) => ({ ...v, open: false }))}
    >
      {props.children(() => setState((v) => ({ ...v, open: true })))}
    </Popconfirm>
  );
}
